









import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import { TIE } from '../constants';
@Component
export default class GameOver extends Vue {
  @Prop({ required: true }) active!: boolean;
  @Prop({ required: true }) close!: Function;
  @Prop({ required: true }) winner!: string;

  get text() {
    return this.winner === TIE
      ? "Whelp...it's a tie!"
      : `The winner is ${this.winner}`;
  }
}
